import {UserUtil} from './utils/UserUtil';
import {Validator} from './utils/Validator';
import {Scheduler} from './utils/Scheduler';
import {AppComponent} from './app.component';
import {PageMapping} from './utils/PageMapping';
import {APP_ROUTES_PROVIDER} from './app.routes';
import {CdkTableModule} from '@angular/cdk/table';
import {UserService} from './service/user.service';
import {TeamComponent} from './team/team.component';
import {UserNavigator} from './utils/UserNavigator';
import {HomeModule} from './borrow/home/home.module';
import {ConfigService} from './service/config.service';
import {LoginComponent} from './login/login.component';
import {TermsComponent} from './terms/terms.component';
import {TooltipModule} from './tooltip/tooltip.module';
import {ApiServiceService} from './api-service.service';
import {LeftDivModule} from './leftdiv/left-div.module';
import {StorageService} from './service/storage.service';
import {ContactService} from './service/contact.service';
import {PartnerService} from './service/partner.service';
import {InvestModule} from './invest/home/invest.module';
import {AnalyticsTracker} from './utils/AnalyticsTracker';
import {CustomDateAdapter} from './utils/CustomDateAdapter';
import {ProfileComponent} from './profile/profile.component';
import {ToasterComponent} from './toaster/toaster.component';
import {PortfolioService} from './service/portfolio.service';
import {ArticleComponent} from './articles/article.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NotFoundComponent} from './notfound/notfound.component';
import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {RegisterComponent} from './register/register.component';
import {CampaignModule} from './invest/campaign/campaign.module';
import {LoanDetailsService} from './service/loan-details.service';
import {RatingFilter} from './portfolio-creation/manualinvest/filters/rating.filter';
import {ReferralsComponent} from './referrals/referrals.component';
import {ContactusComponent} from './contactus/contactus.component';
import {ContactUsModule} from './views/contact-us/contact-us.module';
import {LocationFilter} from './portfolio-creation/manualinvest/filters/location.filter';
import {LoandetailComponent} from './loandetail/loandetail.component';
import {RejectloanComponent} from './rejectloan/rejectloan.component';
import {NopassbookComponent} from './nopassbook/nopassbook.component';
import {PartnerfaqComponent} from './partnerfaq/partnerfaq.component';
import {PeerToPeerComponent} from './articles/peer-to-peer.component';
import {LenderDetailsService} from './service/lender-details.service';
import {LoanDebtInfoGuard} from './residence-info/loan-debt-info.guard';
import {ChannelPartnerService} from './service/channel-partner.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {LenderintroComponent} from './lenderintro/lenderintro.component';
import {SalarycheckComponent} from './salarycheck/salarycheck.component';
import {LoanApplicationService} from './service/loan-application.service';
import {CommonSectionsModule} from './views/common/common-sections.module';
import {PartnertermsComponent} from './partnerterms/partnerterms.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {InvestmentNavigator} from './utils/investment-navigator';
import {PanBackLinkResolver} from './pan-verification/pan-back-link.resolver';
import {SingleRatingFilter} from './portfolio-creation/manualinvest/filters/single-rating.filter';
import {LendersummaryComponent} from './lendersummary/lendersummary.component';
import {LenderinitialComponent} from './lenderinitial/lenderinitial.component';
import {LenderconsentComponent} from './lenderconsent/lenderconsent.component';
import {PrivacypolicyComponent} from './privacypolicy/privacypolicy.component';
import {LoanAgreementComponent} from './loanAgreement/loanAgreement.component';
import {LenderDashboardLinkProvider} from './utils/lenderDashboardLinkProvider';
import {AuthTokenInterceptor} from './http/interceptors/auth-token.interceptor';
import {HttpErrorInterceptor} from './http/interceptors/http-error.interceptor';
import {FullPageLoaderModule} from './full-page-loader/full-page-loader.module';
import {TransactionTypeFilter} from './passbook/filters/transaction-type-filter';
import {LenderpassbookComponent} from './lenderpassbook/lenderpassbook.component';
import {InvestorwalletComponent} from './investorwallet/investorwallet.component';
import {CampaignPopUpComponent} from './campaign-pop-up/campaign-pop-up.component';
import {PanInformationResolver} from './pan-verification/pan-information.resolver';
import {ChannelPartnerIdResolver} from './borrow/home/channel-partner-id.resolver';
import {LenderPersonalInfoGuard} from './residence-info/lender-personal-info.guard';
import {BrowserModule, BrowserTransferStateModule} from '@angular/platform-browser';
import {PhoneVerificationGuard} from './phoneverification/phone-verification.guard';
import {HorizontalLoaderModule} from './horizontal-loader/horizontal-loader.module';
import {ReferralConsentResolver} from './referral-consent/referral-consent.resolver';
import {PassbookDateRangeFilter} from './passbook/filters/passbook-date-range.filter';
import {FilledPercentageFilter} from './portfolio-creation/manualinvest/filters/filled-percentage.filter';
import {CreatePortfolioComponent} from './create-portfolio/create-portfolio.component';
import {ReferralConsentComponent} from './referral-consent/referral-consent.component';
import {SessionExpiryErrorHandler} from './error-handlers/session-expiry-error-handler';
import {LoanResidenceInfoResolver} from './residence-info/loan-residence-info.resolver';
import {ResidenceInfoLinksResolver} from './residence-info/residence-info-links.resolver';
import {FinzyGetsCertificateComponent} from './articles/finzy-gets-certificate.component';
import {InvestordashboardComponent} from './investordashboard/investordashboard.component';
import {BorrowerCampaignModule} from './borrow/borrower-campaign/borrower-campaign.module';
import {LenderResidenceInfoResolver} from './residence-info/lender-residence-info.resolver';
import {ManualinvestdetailComponent} from './portfolio-creation/manualinvestdetail/manualinvestdetail.component';
import {LenderpersonalinfoComponent} from './lenderpersonalinfo/lenderpersonalinfo.component';
import {CampaignPopUpCheckComponent} from './campaign-pop-up/campaign-pop-up-check.component';
import {ReferralPartnerCodeComponent} from './referral-input/referral-partner-code.component';
import {LenderBankDetailsComponent} from './lender-bank-details/lender-bank-details.component';
import {PassbookDateRangeFilterPipe, TransactionTypeFilterPipe} from './passbook/passbook.pipe';
import {RegistrationsuccessComponent} from './registrationsuccess/registrationsuccess.component';
import {PreferencesDeactivationGuard} from './preferences/preferences-deactivation-guard.service';
import {InterestCertificateComponent} from './interest-certificate/interest-certificate.component';
import {LenderuploaddocumentsComponent} from './lenderuploaddocuments/lenderuploaddocuments.component';
import {DiscardChangesPromptComponent} from './discard-changes-prompt/discard-changes-prompt.component';
import {PortfolioCreationGuard} from './portfolio-creation/guards/portfolio-creation.guard';
import {LenderPhoneVerificationComponent} from './lenderphoneverification/lender-phone-verification.component';
import {InvestmentApplicationFlowModule} from './views/investors/investment-application-flow/investment-application-flow.module';
import {AcceptFormatsDirective} from './utils/directives/accept-formats.directive';
import {InvestmentMetricsComponent} from './investment-metrics/investment-metrics.component';
import {InvestormenuModule} from './investormenu/investormenu.module';
import {IndianCurrencyFormatterModule} from './views/common/indian-currency-formatter/indian-currency-formatter.module';
import {CoolStorageModule} from '@angular-cool/storage';
import {
    AuthGuard,
    BorrowerObstructGuard,
    BorrowGuard,
    LenderGuard,
    LenderObstructGuard,
    NewUserObstructGuard
} from './auth.guard';
import {
    DateAdapter,
    MAT_DATE_LOCALE,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
} from '@angular/material';
import {EmailVerificationModule} from './email-verification/email-verification.module';
import {OnlyUsersWithoutLoanGuard} from './guards/only-users-without-loan.guard';
import {LoginHelper} from './helpers/login.helper';
import {CreditAssessmentInfoResolver} from './borrow/eligibility-check/credit-assessment-info.resolver';
import {CreditAssessmentService} from './service/credit-assessment.service';
import {EligibilityCheckService} from './service/eligibility-check.service';
import {SelectedOptionResolver} from './borrow/eligibility-check/selected-option.resolver';
import {IfaCampaignModule} from './ifa/ifa-campaign/ifa-campaign.module';
import {LoanApplicationInteractor} from './interactors/loan-application.interactor';
import {LenderBankDetailComponent} from './lenderbankdetails/lender-bank-detail.component';
import {OnlyBorrowerApplicantsGuard} from './guards/only-borrower-applicants.guard';
import {OnlyBorrowerApplicantsInProgressGuard} from './guards/only-borrower-applicants-in-progress.guard';
import {PipesModule} from './utils/pipes/pipes.module';
import {SubventionService} from './service/subvention.service';
import {SubventionPreferenceService} from './service/subvention-preference.service';
import {EmiScheduleGenerator} from '@finzy/node-emi-calculator';
import {SubventionUtil} from './utils/subvention-util';
import {WorstEmiScheduleGenerator} from '@finzy/node-emi-calculator/lib/emiCalculator/WorstEmiScheduleGenerator';
import {EffectiveRoiCalculator} from '@finzy/node-emi-calculator/lib/interest/EffectiveRoiCalculator';
import {ChannelPartnerResolver} from './borrow/eligibility-check/eligibility-check-form/channel-partner.resolver';
import {AdvanceEmiPlanService} from './service/advance-emi-plan.service';
import {LoanAgreementModule} from './loanAgreement/loanAgreement.module';
import {VirtualAccountDescriptionPopUpComponent} from './views/virtual-account-description-pop-up/virtual-account-description-pop-up.component';
import {LoanMaturedComponent} from './loan-matured/loan-matured.component';
import {InvitationResolver} from './views/accept-invitation/invitation.resolver';
import {PanVerificationStatusResolver} from './views/accept-invitation/pan-verification-status.resolver';
import {InvitationService} from './service/invitation.service';
import {AcceptInvitationModule} from './views/accept-invitation/accept-invitation.module';
import {CashFlowGenerator} from './utils/cash-flow-generator';
import {XirrCalculator} from './service/xirr-calculator';
import {EmiUtil} from './utils/emi.util';
import {WriteOffComponent} from './loandetail/write-off/write-off.component';
import {RateOfReturnTooltipModule} from './rate-of-return-tooltip/rate-of-return-tooltip.module';
import {WriteOffService} from './service/write-off.service';
import {ChartDataUtil} from './doughnut/chart-data.util';
import {ConfirmPopUpModule} from './comfirm-pop-up/confirm-pop-up.module';
import {DoughnutModule} from './doughnut/doughnut.module';
import {MaskedAadhaarInfoModule} from './masked-aadhaar-info/masked-aadhaar-info.module';
import {DownloadFileModule} from './common/download-file/download-file.module';
import {EmailVerificationModalComponent} from './email-verification-modal/email-verification-modal.component';
import {PreferencesService} from './service/preferences.service';
import {AutoInvestGuard} from './portfolio-creation/auto-invest/guards/auto-invest.guard';
import {SetSerializerInterceptor} from './http/interceptors/set-serializer.interceptor';
import {ActiveApplicationValidationGuard} from './guards/active-application-validation.guard';
import {NoOpComponent} from './no-op.component';
import {ChannelPartnerLogoResolver} from './borrow/home/channel-partner-logo.resolver';
import {BorrowerMenuModule} from './borrow/borrower-dashboard/borrower-menu/borrower-menu.module';
import {ButtonModule} from './views/common/button/button.module';
import {OnlyUsersWithoutLoanApplicationGuard} from './guards/only-users-without-loan-application.guard';
import {LoginService} from './service/login.service';
import {LoginInteractor} from './interactors/login.interactor';
import {LenderDashboardNomineeComponent} from './profile/lender-dashboard-nominee/lender-dashboard-nominee.component';
import {LenderNomineeComponent} from './lender-nominee/lender-nominee.component';
import {NomineeService} from './service/nominee.service';
import {NomineeFormComponent} from './lender-nominee/nominee-form/nominee-form.component';
import {JwtUtil} from './utils/JwtUtil';
import {AuthTokenValidityInterceptor} from './http/interceptors/auth-token-validity.interceptor';
import {EmiMoratoriumService} from './service/emi-moratorium.service';
import {InvestmentPreferencesResolver} from './resolvers/investment-preferences.resolver';
import {BorrowerPhoneNumberVerificationResolver} from './borrow/borrower-phone-number-verification/borrower-phone-number-verification.resolver';
import {StringUtil} from './utils/string.util';
import {LoanSettlementService} from './service/loan-settlement.service';
import {LenderCommissionRateUtil} from './utils/lender/lender-commission-rate.util';
import {LenderReturnCalculator} from './service/lender-return-calculator';
import {LoanRestructureService} from './service/loan-restructure.service';
import {RestructuredLoanDetailComponent} from './loandetail/restructured-loan-detail/restructured-loan-detail.component';
import {ChannelPartnerTransactionIdResolver} from './borrow/home/channel-partner-transaction-id.resolver';
import {Tracker} from './utils/tracker';
import {InvestorRelationsComponent} from './investor-relations/investor-relations.component';
import { BarGraphModule } from './bar-graph/bar-graph.module';
import { AssetPerformanceService } from './service/asset-performance.service';
import { RemoveIfFeatureOffDirective } from './directives/remove-if-feature-off.directive';
import { RemoveIfFeatureOnDirective } from './directives/remove-if-feature-on.directive';
import { CameraDirectiveModule } from './directives/camera-directive.module';
import { UserAttributeService } from './service/finzy-flex/user/user-attribute.service';
import { ProductService } from './service/finzy-flex/product/product.service';
import { UserAttributeResolver } from './views/investors/finzy-flex/user-attribute/user-attribute.resolver';
import { ProductResolver } from './resolvers/product.resolver';
import { AccountService } from './service/finzy-flex/account/account.service';
import { WithdrawalService } from './service/withdrawal.service';
import { SharedService } from './service/shared.service';
import { PaymentCollectionService } from './service/payment-collection.service';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        TermsComponent,
        ReferralsComponent,
        ProfileComponent,
        LenderDashboardNomineeComponent,

        NoOpComponent,
        PassbookDateRangeFilterPipe,
        TransactionTypeFilterPipe,

        AcceptFormatsDirective,

        ArticleComponent,
        PeerToPeerComponent,
        FinzyGetsCertificateComponent,

        ToasterComponent,
        DiscardChangesPromptComponent,
        LenderintroComponent,
        ReferralConsentComponent,
        LenderuploaddocumentsComponent,
        LenderPhoneVerificationComponent,
        LendersummaryComponent,
        InvestordashboardComponent,

        LenderinitialComponent,
        CreatePortfolioComponent,
        ContactusComponent,
        LoandetailComponent,
        LenderpassbookComponent,
        InvestorwalletComponent,
        LenderconsentComponent,
        RejectloanComponent,
        ManualinvestdetailComponent,
        PrivacypolicyComponent,
        LenderpersonalinfoComponent,
        NopassbookComponent,
        NotFoundComponent,
        TeamComponent,
        SalarycheckComponent,
        LenderBankDetailsComponent,
        LenderBankDetailComponent,
        RegisterComponent,
        RegistrationsuccessComponent,
        PartnerfaqComponent,
        PartnertermsComponent,
        InterestCertificateComponent,
        CampaignPopUpCheckComponent,
        CampaignPopUpComponent,
        InvestmentMetricsComponent,
        ReferralPartnerCodeComponent,
        VirtualAccountDescriptionPopUpComponent,
        LoanMaturedComponent,
        WriteOffComponent,
        LenderNomineeComponent,
        NomineeFormComponent,
        RestructuredLoanDetailComponent,
        InvestorRelationsComponent,
        RemoveIfFeatureOffDirective,
        RemoveIfFeatureOnDirective
    ],
    imports: [
        BrowserModule.withServerTransition({appId: 'finzy-frontend'}),
        FormsModule,
        LeftDivModule,
        HttpClientModule,
        APP_ROUTES_PROVIDER,
        ReactiveFormsModule,
        CommonSectionsModule,
        BrowserAnimationsModule,
        InvestmentApplicationFlowModule,
        BrowserTransferStateModule,
        FullPageLoaderModule,
        HorizontalLoaderModule,
        TooltipModule,
        ContactUsModule,
        LoanAgreementModule,
        DoughnutModule,
        BarGraphModule,
        EmailVerificationModule,
        MaskedAadhaarInfoModule,

        MatCardModule,
        MatIconModule,
        MatMenuModule,
        MatSortModule,
        MatTabsModule,
        MatInputModule,
        MatRadioModule,
        MatTableModule,
        MatButtonModule,
        MatDialogModule,
        MatRippleModule,
        MatSelectModule,
        MatToolbarModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSlideToggleModule,
        MatAutocompleteModule,
        MatButtonToggleModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,

        CdkTableModule, CoolStorageModule,
        InvestModule,
        HomeModule,
        CampaignModule,
        IfaCampaignModule,
        BorrowerCampaignModule,
        InvestormenuModule,
        IndianCurrencyFormatterModule,
        PipesModule,
        BorrowerMenuModule,
        AcceptInvitationModule, RateOfReturnTooltipModule, ConfirmPopUpModule, DownloadFileModule, ButtonModule,CameraDirectiveModule
    ],

    entryComponents: [CreatePortfolioComponent, RejectloanComponent, NopassbookComponent,
        SalarycheckComponent, LoanAgreementComponent, CampaignPopUpComponent, DiscardChangesPromptComponent, EmailVerificationModalComponent,
        VirtualAccountDescriptionPopUpComponent],

    providers: [AssetPerformanceService, ApiServiceService, PartnerService, AnalyticsTracker, PageMapping, AuthGuard, BorrowGuard, LenderGuard, NewUserObstructGuard, LenderObstructGuard, BorrowerObstructGuard,
        PreferencesDeactivationGuard, LoginHelper, ConfigService, LenderDetailsService, LoanDetailsService, LenderDashboardLinkProvider, UserUtil, UserService, ChannelPartnerService, UserNavigator,
        PanInformationResolver, PanBackLinkResolver, ResidenceInfoLinksResolver, ChannelPartnerResolver, ReferralConsentResolver, LoanResidenceInfoResolver, ChannelPartnerIdResolver, LenderPersonalInfoGuard, LoanDebtInfoGuard, LenderResidenceInfoResolver,
        PhoneVerificationGuard, Validator, Scheduler, StorageService, SharedService, PortfolioService, PortfolioCreationGuard,
        SessionExpiryErrorHandler, FilledPercentageFilter, LocationFilter, RatingFilter, SingleRatingFilter, PassbookDateRangeFilter, TransactionTypeFilter, ContactService, LoanApplicationInteractor, LoanApplicationService,
        InvestmentNavigator, OnlyUsersWithoutLoanGuard, EligibilityCheckService, CreditAssessmentService, CreditAssessmentInfoResolver, SelectedOptionResolver, OnlyBorrowerApplicantsGuard, OnlyBorrowerApplicantsInProgressGuard,
        SubventionService, SubventionPreferenceService, SubventionUtil, AdvanceEmiPlanService, LoginService, LoginInteractor, NomineeService,
        CashFlowGenerator, XirrCalculator, EmiUtil, InvitationResolver, PanVerificationStatusResolver, InvitationService, WriteOffService, PreferencesService, EmiMoratoriumService,
        ChartDataUtil, AutoInvestGuard, ActiveApplicationValidationGuard, ChannelPartnerLogoResolver, OnlyUsersWithoutLoanApplicationGuard, JwtUtil, InvestmentPreferencesResolver, UserAttributeResolver, ProductResolver,
        BorrowerPhoneNumberVerificationResolver, StringUtil, LoanSettlementService, LenderCommissionRateUtil, LenderReturnCalculator, LoanRestructureService, ChannelPartnerTransactionIdResolver, Tracker, UserAttributeService, ProductService,
        AccountService, WithdrawalService, PaymentCollectionService,
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'en-IN'
        },
        {
            provide: LOCALE_ID,
            useValue: 'en-IN'
        },
        {
            provide: ErrorHandler,
            useClass: SessionExpiryErrorHandler
        }, {
            provide: DateAdapter, useClass: CustomDateAdapter
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenValidityInterceptor,
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: SetSerializerInterceptor,
            multi: true
        },
        {
            provide: EmiScheduleGenerator,
            useFactory: () => new EmiScheduleGenerator()
        },
        {
            provide: WorstEmiScheduleGenerator,
            useFactory: () => new WorstEmiScheduleGenerator(new EmiScheduleGenerator())
        },
        {
            provide: EffectiveRoiCalculator,
            useFactory: () => new EffectiveRoiCalculator(new WorstEmiScheduleGenerator(new EmiScheduleGenerator()), new EmiScheduleGenerator())
        }],
    bootstrap: [AppComponent]
})

export class AppModule {
}
